<script>
    export let checkout = false;
</script>

<div class="bank-policy mb-4" class:checkout class:mb-5={!checkout}>
    <h2 class="h5 mb-2">Payment Policy for Travel Partners</h2>
    <p>
        All bookings must be prepaid via bank transfer no later than 36 hours prior to the scheduled
        transfer.
    </p>
    <p>
        Please note that if payment is not received within this timeframe, the transfer will be
        automatically cancelled without further notice.
    </p>
    <p>
        Kindly ensure that the booking reference and client name are clearly stated in the payment
        details
        to avoid any delays in confirmation.
    </p>
    <p>
        Upon completion of the transfer reservation, please send the proof of payment to info@regentmile.gr,
        indicating in the email subject the booking reference and client name, so that your reservation can be
        promptly processed and confirmed.
    </p>
    <p class="mb-1">
        <strong>Bank Details</strong>
    </p>
    <table>
        <tbody>
        <tr>
            <td class="fw-semibold">Bank:</td>
            <td>Piraeus Bank</td>
        </tr>
        <tr>
            <td class="fw-semibold">Beneficiary Name:</td>
            <td>RITZENT MILE HELLENIC TRANSPORT SERVICES</td>
        </tr>
        <tr>
            <td class="fw-semibold">IBAN:</td>
            <td>GR14 0172 7560 0057 5610 5164 772</td>
        </tr>
        <tr>
            <td class="fw-semibold">BIC / SWIFT:</td>
            <td>PIRBGRAA</td>
        </tr>
        </tbody>
    </table>
</div>

<style>
    .bank-policy.checkout {
        font-size: 14px;
    }
</style>